import { render, staticRenderFns } from "./cis.cattle.io.clusterscanbenchmark.vue?vue&type=template&id=4c863b54&"
import script from "./cis.cattle.io.clusterscanbenchmark.vue?vue&type=script&lang=js&"
export * from "./cis.cattle.io.clusterscanbenchmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports